






































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';

@Component
export default class DeliveryInfo extends Vue {
    private eventEmit = {
        eventChangeOrderType: 'eventChangeOrderType',
    };
    @Prop({default: null})
    private customer: any;
    @Prop({default: false})
    private invertOrder: any;
    @Prop({default: null})
    private invertObject: any;

    private orderType = 0;


    zeroPad = (num, places) => String(num).padStart(places, '0');
    get warehouse() {
        let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
        return tmp ? tmp.filter(p => p.StoreType === (this.invertOrder ? 2 : 1) && !p.IsHidden) : null;
    }

    get chinaStore() {
        let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
        return tmp ? tmp.filter(p => p.StoreType === (this.invertOrder ? 2 : 1) && !p.IsHidden) : null;
    }

    private onChangeOrderType() {
        this.$emit(this.eventEmit.eventChangeOrderType, this.orderType);
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async onChangeChinaStoreID() {
        this.$emit('chinaStoreChanged');
    }

    get chinaStoreAddress() {
        if (this.customer && this.customer.ChinaStoreID && this.chinaStore) {
            const result = this.chinaStore.find(c => c.ID == this.customer.ChinaStoreID);

            if (result) {
               return `${result.Receiver}${this.zeroPad(this.customer.ID, 3)} - ${result.Phone} - ${result.Address}${this.zeroPad(this.customer.ID, 3)}`;
            }
        }
        return '';
    }

    get chinaStoreDescription() {
        if (this.customer && this.customer.ChinaStoreID && this.chinaStore) {
            const result = this.chinaStore.find(c => c.ID == this.customer.ChinaStoreID);

            if (result) {
               return result.Description ? JSON.parse(result.Description) : null;
            }
        }
        return '';
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
    }
}
